import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { setRouterNavigate } from './router'

/** Bridges imperative Router singleton to React Router navigate. */
export default function RouterNavigateBinder() {
  const navigate = useNavigate()
  useEffect(() => {
    setRouterNavigate((to, opts) => {
      if (typeof to === 'number') navigate(to)
      else navigate(to, { replace: opts?.replace })
    })
  }, [navigate])
  return null
}
